export const servicesHighlightsTokens = {
  colors: {
    background: "#f3f7ff",
    panel: "#ffffff",
    panelBorder: "rgba(7, 24, 55, 0.07)",
    text: "#081735",
    textSoft: "#40506a",
    textMuted: "#69758a",
    accent: "#125df4",
    accentSoft: "#edf4ff",
    accentBorder: "rgba(18, 93, 244, 0.16)",
    featureBorder: "rgba(8, 23, 53, 0.10)",
    featureHoverBorder: "rgba(18, 93, 244, 0.34)",
    mediaFallback: "#eef3fb",
    badgeDivider: "rgba(8, 23, 53, 0.08)",
    shadow: "0 26px 70px rgba(8, 23, 53, 0.10)",
    softShadow: "0 16px 36px rgba(8, 23, 53, 0.10)",
    ctaShadow: "0 16px 28px rgba(18, 93, 244, 0.24)",
  },
  maxWidth: {
    md: "1120px",
    lg: "1320px",
    xl: "1510px",
    full: "100%",
  },
  radius: {
    panel: 24,
    media: 24,
    tile: 8,
    badge: 8,
    icon: 999,
    button: 8,
  },
  spacing: {
    sectionY: 30,
    sectionX: 20,
    panelY: 44,
    panelX: 56,
    desktopGap: 56,
    contentGap: 24,
    featureGap: 12,
    ctaGap: 18,
    mobileSectionY: 14,
    mobileSectionX: 10,
    mobilePanelY: 22,
    mobilePanelX: 16,
  },
  sizes: {
    contentMaxWidth: 540,
    mediaMinHeight: 520,
    iconBadge: 44,
    featureIcon: 44,
    badgeWidth: 188,
    badgeIcon: 44,
    ctaHeight: 54,
    mobileMediaMinHeight: 280,
  },
  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    overline: {
      fontSize: 12,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
      textTransform: "uppercase" as const,
    },
    title: {
      fontSize: 42,
      lineHeight: 1.05,
      fontWeight: 850,
      letterSpacing: 0,
    },
    description: {
      fontSize: 15,
      lineHeight: 1.5,
      fontWeight: 500,
      letterSpacing: 0,
    },
    featureTitle: {
      fontSize: 15,
      lineHeight: 1.25,
      fontWeight: 800,
      letterSpacing: 0,
    },
    badgeTitle: {
      fontSize: 13,
      lineHeight: 1.35,
      fontWeight: 800,
      letterSpacing: 0,
    },
    cta: {
      fontSize: 15,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
    },
    secondaryCta: {
      fontSize: 14,
      lineHeight: 1,
      fontWeight: 800,
      letterSpacing: 0,
    },
  },
  motion: {
    tile: "transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease",
    image: "transform 520ms ease",
    cta: "transform 180ms ease, box-shadow 180ms ease",
  },
} as const;

export type ServicesHighlightsMaxWidthToken = keyof typeof servicesHighlightsTokens.maxWidth;
